const ErrorType = {
  MalformedTxs: 'MalformedTxs',
  AccountStateClassCreation: 'AccountStateClassCreation',
  AccountStateCreation: 'AccountStateCreation',
}

export default ErrorType
